import type { PetPlanParseResult } from './petPlanTypes';
import { parseGuapecoFile } from './parsers/guapecoParser';

export async function parsePetPlanFile(file: File): Promise<PetPlanParseResult> {
  try {
    // Strategy Pattern: Detect provider based on file content or name
    // Currently only Guapeco is supported.
    return await parseGuapecoFile(file);
  } catch (error) {
    console.error('[parsePetPlanFile] failed', error);
    throw error;
  }
}
